import React, {Fragment} from 'react'

import {
  EuiBreadcrumbs,
  EuiSpacer
} from '@elastic/eui'


export default function ManualBreadcrumbs() {

  const breadcrumbs = [
    {
      text: 'InstarVision',
      href: '/de/Software/Windows/InstarVision/'
    },
    {
      text: 'InstarVision (Phone)',
      href: '/de/Software/Windows/InstarVision/Windows_Phone/',
    },
    {
      text: 'InstarVision (Metro)',
      href: '/de/Software/Windows/InstarVision/Metro/',
    },
    {
      text: 'BlueIris',
      href: '/de/Software/Windows/Blue_Iris_v5',
    },
    {
      text: 'go1984',
      href: '/de/Software/Windows/go1984/',
    },
    {
      text: 'iSpy',
      href: '/de/Software/Windows/iSpy/',
    },
    {
      text: 'Sighthound',
      href: '/de/Software/Windows/Sighthound/',
    },
    {
      text: 'VLC',
      href: '/de/Software/Windows/VLC_Player/',
    },
    {
      text: '◄ Windows',
      href: '/de/Software/Windows/',
    }
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        max={11}
        aria-label="Software Platform for your INSTAR IP Camera"
      />
      <EuiSpacer />
    </Fragment>
  );
}